var _path, _path2, _g, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFamilyHealthHistoryActive = function SvgFamilyHealthHistoryActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8679 14.1695C20.4386 14.1695 20.0641 13.8533 20.0023 13.4158C19.9358 12.9363 20.2683 12.4942 20.7478 12.4277C21.9611 12.2573 22.8769 11.205 22.8793 9.97767C22.8793 8.76083 22.0066 7.73183 20.8038 7.53467C20.3278 7.4565 20.0046 7.00617 20.0828 6.529C20.1621 6.05183 20.6089 5.73217 21.0884 5.808C23.1394 6.14517 24.6293 7.89983 24.6293 9.98C24.6246 12.0742 23.0601 13.8708 20.9893 14.1613C20.9484 14.1672 20.9076 14.1695 20.8679 14.1695Z",
    fill: "#3175F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5854_8669",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 16,
    width: 5,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1411 16.332H26.5674V21.6165H22.1411V16.332Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5854_8669)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3383 21.6165C23.986 21.6165 23.6535 21.4019 23.5205 21.053C23.3478 20.6015 23.5753 20.0952 24.0268 19.9237C24.8178 19.6227 24.8178 19.2902 24.8178 19.1304C24.8178 18.6194 24.168 18.2624 22.887 18.071C22.4098 17.9987 22.0796 17.5542 22.1508 17.0747C22.222 16.5964 22.6653 16.2779 23.1471 16.3397C25.974 16.7632 26.5678 18.0909 26.5678 19.1304C26.5678 19.765 26.3181 20.9235 24.6498 21.5594C24.5471 21.5979 24.4421 21.6165 24.3383 21.6165Z",
    fill: "#3175F6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8678 18.5625C11.0958 18.5625 7.79065 18.9032 7.79065 20.5248C7.79065 22.1593 11.0958 22.5023 13.8678 22.5023C16.6398 22.5023 19.9438 22.1628 19.9438 20.5447C19.9438 18.9067 16.6398 18.5625 13.8678 18.5625ZM13.8678 24.2523C11.9323 24.2523 6.04065 24.2523 6.04065 20.5248C6.04065 16.8125 11.9323 16.8125 13.8678 16.8125C15.8033 16.8125 21.6938 16.8125 21.6938 20.5447C21.6938 24.2523 16.0086 24.2523 13.8678 24.2523Z",
    fill: "#3175F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8678 6.41406C11.8938 6.41406 10.2885 8.02056 10.2885 9.99456C10.285 10.9512 10.6513 11.8461 11.3221 12.5216C11.993 13.1971 12.8866 13.5716 13.8386 13.5751L13.8678 14.4501V13.5751C15.8418 13.5751 17.4483 11.9697 17.4483 9.99456C17.4483 8.02056 15.8418 6.41406 13.8678 6.41406ZM13.8678 15.3251H13.8363C12.413 15.3204 11.0795 14.7627 10.0808 13.7547C9.07982 12.7479 8.53265 11.4109 8.53848 9.99106C8.53848 7.05573 10.929 4.66406 13.8678 4.66406C16.8078 4.66406 19.1983 7.05573 19.1983 9.99456C19.1983 12.9334 16.8078 15.3251 13.8678 15.3251Z",
    fill: "#3175F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86664 14.1697C6.82698 14.1697 6.78614 14.1674 6.74531 14.1616C4.67448 13.8711 3.11114 12.0744 3.10648 9.98255C3.10648 7.90005 4.59631 6.14539 6.64731 5.80822C7.13848 5.73122 7.57364 6.05439 7.65298 6.52922C7.73114 7.00639 7.40798 7.45672 6.93198 7.53489C5.72914 7.73205 4.85648 8.76105 4.85648 9.98022C4.85881 11.2052 5.77464 12.2587 6.98681 12.4279C7.46631 12.4944 7.79881 12.9366 7.73231 13.4161C7.67048 13.8536 7.29598 14.1697 6.86664 14.1697Z",
    fill: "#3175F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39745 21.6163C3.29361 21.6163 3.18861 21.5976 3.08595 21.5591C1.41645 20.9221 1.16678 19.7636 1.16678 19.1301C1.16678 18.0918 1.76061 16.7629 4.58861 16.3394C5.07045 16.2788 5.51145 16.5961 5.58378 17.0744C5.65494 17.554 5.32478 17.9985 4.84761 18.0708C3.56661 18.2621 2.91678 18.6191 2.91678 19.1301C2.91678 19.29 2.91678 19.6213 3.70895 19.9235C4.16044 20.095 4.38794 20.6013 4.21528 21.0528C4.08228 21.4016 3.74978 21.6163 3.39745 21.6163Z",
    fill: "#3175F6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFamilyHealthHistoryActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/family_health_history_active.c829d19e.svg";
export { ForwardRef as ReactComponent };